import { getToken, RULES_API } from "../util/auth";

const BASE = RULES_API;

export async function post<T>(url: string, body: any): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${url}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json() as Promise<T>;
}

export const autoFillMotor = async (rows: any, age?: number) => {
  const res = await post<{ ok: boolean; data: string[] }>(
    "/autofill/motor",
    { rows, age }
  );
  return res.data;
};

export const autoFillSensory = async (rows: any, age?: number) => {
  const res = await post<{ ok: boolean; data: string[] }>(
    "/autofill/sensory",
    { rows, age }
  );
  return res.data;
};

export const autoFillFwave = async (rows: any, age?: number) => {
  const res = await post<{ ok: boolean; data: string[] }>(
    "/autofill/fwave",
    { rows, age }
  );
  return res.data;
};

export const autoFillHreflex = async (rows: any, age?: number) => {
  const res = await post<{ ok: boolean; data: string[] }>(
    "/autofill/hreflex",
    { rows, age }
  );
  return res.data;
};

export const generateConclusion = async (payload: {
  findings: string[];
  patient: { age?: string | number; sex?: string };
  patientNote: string;
  clinicianOpinion: string;
  context: any[];
}) => {
  const res = await post<{ ok: boolean; data: string }>(
    "/conclusion",
    {
      ...payload,
      age: payload.patient?.age ? Number(payload.patient.age) : undefined,
    }
  );
  return res.data;
};

export const generateFindings = (payload: any) =>
  post<{ ok: boolean; data: string[] }>("/findings/combine", payload);
